import React, { useRef } from "react";
import PropTypes from "prop-types";
import classNames from "../../../utils/classNames";
import CloseButton from "../../atoms/CloseButton";
import { useScrollLock } from "../../../hooks/useScrollLock";
import "./index.scss";

const DropDownWithSearch = ({
  dropdownRef,
  searchTerm,
  handleSearchChange,
  onSearchKeyDown,
  placeholder,
  items,
  renderItem,
  noItemsMessage,
  className,
  onClose,
  closeLabel,
  header,
  footer,
}) => {
  const listRef = useRef(null);
  useScrollLock(listRef);
  const rootClassName = classNames("dropdown-with-search", className);
  const dialogProps = onClose ? { role: "dialog", "aria-modal": "true" } : {};

  return (
    <div className={rootClassName} ref={dropdownRef} {...dialogProps}>
      {onClose && (
        <CloseButton className="dropdown-with-search__close" ariaLabel={closeLabel} onClick={onClose} />
      )}
      {header ? (
        <div className="dropdown-with-search__header">
          {header}
        </div>
      ) : null}
      <div className="dropdown-with-search__field-wrapper">
        <input
          type="text"
          className="dropdown-with-search__field"
          placeholder={placeholder}
          value={searchTerm}
          onChange={handleSearchChange}
          onKeyDown={onSearchKeyDown}
        />
      </div>
      <div className="dropdown-with-search__list" ref={listRef}>
        {items.length > 0 ? (
          items.map((item, index) => renderItem(item, index))
        ) : (
          <p className="dropdown-with-search__empty">{noItemsMessage}</p>
        )}
      </div>
      {footer ? (
        <div className="dropdown-with-search__footer">
          {footer}
        </div>
      ) : null}
    </div>
  );
};

DropDownWithSearch.propTypes = {
  dropdownRef: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({ current: PropTypes.instanceOf(Element) })
  ]),
  searchTerm: PropTypes.string.isRequired,
  handleSearchChange: PropTypes.func.isRequired,
  onSearchKeyDown: PropTypes.func,
  placeholder: PropTypes.string,
  items: PropTypes.array.isRequired,
  renderItem: PropTypes.func.isRequired,
  noItemsMessage: PropTypes.string,
  className: PropTypes.string,
  onClose: PropTypes.func,
  closeLabel: PropTypes.string,
  header: PropTypes.node,
  footer: PropTypes.node,
};

DropDownWithSearch.defaultProps = {
  placeholder: "Search...",
  noItemsMessage: "No items found.",
  className: "",
  onClose: undefined,
  onSearchKeyDown: undefined,
  closeLabel: "Close",
  header: undefined,
  footer: undefined,
};

export default DropDownWithSearch;
